var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_vm._v(" 云ICU后台管理系统©2021 Created by 优屏研发团队 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }